import { BrowserRouter } from 'react-router-dom';
import Routes from '@/routes/routes';
import ProgressAlerts from './shared/progressAlerts/ProgressAlert';

const App = () => {
  return (
    <BrowserRouter>
      <ProgressAlerts />
      <Routes />
    </BrowserRouter>
  );
};

export default App;
